import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import BasicInfo from "./BasicInfo";
import leftArrow from "assets/icon/left-arrow.svg";
import InfoIcon from "assets/icon/info-icon.svg";
import MedicationIcon from "assets/icon/medication-icon.svg";
import ClinicalIcon from "assets/icon/clinical-icon.svg";
import InsuranceIcon from "assets/icon/insurance-icon.svg";
import PreferencesIcon from "assets/icon/preferences-icon.svg";
import DocumentIcon from "assets/icon/document-icon.svg";
import ProgramIcon from "assets/icon/program.icon.svg";
import AuditIcon from "assets/icon/audit-icon.svg";
import plusIcon from "assets/icon/plus-rx.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Container } from "reactstrap";
import Medication from "./Medication";
import Clinical from "./Clinic";
import Preferences from "./Preferences";
import Documents from "./Documents";
const PatientInformation = () => {
  const [active, setActive] = useState("tab-1");
  const navigate = useNavigate();
  const handleClick = (e) => {
    setActive(e);
  };
  const location = useLocation();
  const rowData = location.state;
  return (
    <Container fluid className="bg-white layout-alignment rounded pb-0">
      <div className="d-flex justify-content-between align-items-center section-devider-border pb-2 cursor-pointer">
        <div>
          <img
            src={leftArrow}
            className="cursor-pointer left-arrow-btn"
            onClick={() => navigate(-1)}
          />
          <span className="heading-text-patient">
            {rowData.lastname + " " + rowData.firstname}
          </span>
          <span className="row-patient-title">DOB: </span>
          <span className="row-patient-des">{rowData.dateofbirth}</span>{" "}
          <span className="row-patient-title">Phone:</span>{" "}
          <span className="row-patient-des">{rowData.primaryphone}</span>
        </div>
        <div className="d-flex align-items-center justify-content-between gap-2">
          <div className="active-orders-box-patient">Active Orders: 01</div>
          <Button color="primary">
            <img src={plusIcon} /> Create New Rx
          </Button>
        </div>
      </div>
      <div className="bin_info">
        <div className="btn-container">
          <div className="btncroll">
            <button
              className={`btn-tab ${active === "tab-1" ? "active" : ""}`}
              id="tab-1"
              onClick={() => handleClick("tab-1")}
            >
              <img src={InfoIcon} alt="" style={{ marginRight: "10px" }} />
              Basic Info
            </button>
            <button
              id="tab-2"
              className={`btn-tab ${active === "tab-2" ? "active" : ""}`}
              onClick={() => handleClick("tab-2")}
            >
              {" "}
              <img
                src={MedicationIcon}
                alt=""
                style={{ marginRight: "10px" }}
              />
              Medication
            </button>
            <button
              id="tab-3"
              className={`btn-tab ${active === "tab-3" ? "active" : ""}`}
              onClick={() => handleClick("tab-3")}
            >
              {" "}
              <img src={ClinicalIcon} alt="" style={{ marginRight: "10px" }} />
              Clinical
            </button>
            <button
              id="tab-4"
              className={`btn-tab ${active === "tab-4" ? "active" : ""}`}
              onClick={() => handleClick("tab-4")}
            >
              {" "}
              <img src={InsuranceIcon} alt="" style={{ marginRight: "10px" }} />
              Insurance
            </button>
            <button
              id="tab-5"
              className={`btn-tab ${active === "tab-5" ? "active" : ""}`}
              onClick={() => handleClick("tab-5")}
            >
              {" "}
              <img
                src={PreferencesIcon}
                alt=""
                style={{ marginRight: "10px" }}
              />
              Preferences
            </button>
            <button
              id="tab-6"
              className={`btn-tab ${active === "tab-6" ? "active" : ""}`}
              onClick={() => handleClick("tab-6")}
            >
              {" "}
              <img src={DocumentIcon} alt="" style={{ marginRight: "10px" }} />
              Documents
            </button>
            <button
              id="tab-7"
              className={`btn-tab ${active === "tab-7" ? "active" : ""}`}
              onClick={() => handleClick("tab-7")}
            >
              {" "}
              <img src={ProgramIcon} alt="" style={{ marginRight: "10px" }} />
              Programs
            </button>
            <button
              id="tab-8"
              className={`btn-tab ${active === "tab-8" ? "active" : ""}`}
              onClick={() => handleClick("tab-8")}
            >
              {" "}
              <img src={AuditIcon} alt="" style={{ marginRight: "10px" }} />
              Audit History
            </button>
          </div>
        </div>
      </div>
      <div className="tab-content">
        <div className={`tab-page ${active === "tab-1" ? "active" : ""}`}>
          <BasicInfo />
        </div>
        <div className={`tab-page ${active === "tab-2" ? "active" : ""}`}>
          <Medication />
        </div>
        <div className={`tab-page ${active === "tab-3" ? "active" : ""}`}>
          <Clinical />
        </div>
        <div className={`tab-page ${active === "tab-4" ? "active" : ""}`}>
          In Development
        </div>
        <div className={`tab-page ${active === "tab-5" ? "active" : ""}`}>
          <Preferences />
        </div>
        <div className={`tab-page ${active === "tab-6" ? "active" : ""}`}>
          <Documents />
        </div>
        <div className={`tab-page ${active === "tab-7" ? "active" : ""}`}>
          In Development
        </div>
        <div className={`tab-page ${active === "tab-8" ? "active" : ""}`}>
          {/* <AuditHistory /> */}
        </div>
      </div>
    </Container>
  );
};
export default PatientInformation;
